<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['action'],
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <div
      class="shadow-sm bg-n-slate-12 dark:bg-n-slate-7 rounded-2xl items-center gap-3 inline-flex mb-2 max-w-[25rem] min-h-[1.875rem] min-w-[15rem] px-6 py-3 text-left"
    >
      <div class="text-sm font-medium text-white dark:text-white">
        {{ message }}
      </div>
      <div v-if="action">
        <router-link
          v-if="action.type == 'link'"
          :to="action.to"
          class="font-medium cursor-pointer select-none text-n-blue-10 hover:text-n-brand"
        >
          {{ action.message }}
        </router-link>
        <!-- Ação no próprio toast (ex.: Desfazer). Alvo de 44px de altura. -->
        <button
          v-else-if="action.type === 'button'"
          type="button"
          data-testid="snackbar-action"
          class="-my-3 min-h-11 rounded-lg px-2 text-sm font-semibold text-n-blue-10 hover:text-n-brand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-n-blue-9"
          @click="$emit('action')"
        >
          {{ action.message }}
        </button>
      </div>
    </div>
  </div>
</template>
